import { render, staticRenderFns } from "./DirectMessagingChat.vue?vue&type=template&id=8c45baa0"
import script from "./DirectMessagingChat.vue?vue&type=script&lang=ts"
export * from "./DirectMessagingChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports